/**
 * Note: 路由配置项
 *
 * path: '/path'                    // 路由路径
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
	title: 'title'                  // 设置该路由在侧边栏的名字
	icon: 'icon-name'                // 设置该路由的图标
	activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
	query: '{"id": 1}'             // 访问路由的默认传递参数
	hidden: true                   // 当设置 true 的时候该路由不会在侧边栏出现 
    hideTab: true                   //当设置 true 的时候该路由不会在多标签tab栏出现
  }
 */

import type { RouteRecordRaw } from 'vue-router'
import { PageEnum } from '@/enums/pageEnum'
import Layout from '@/layout/default/index.vue'

export const LAYOUT = () => Promise.resolve(Layout)

export const INDEX_ROUTE_NAME = Symbol()

export const constantRoutes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: PageEnum.INDEX
    },

    {
        path: PageEnum.ERROR_403,
        component: () => import('@/views/error/403.vue')
    },
    {
        path: PageEnum.ERROR_404,
        component: () => import('@/views/error/404.vue')
    },
    //
    {
        path: PageEnum.INDEX,
        component: () => import('@/views/index/index.vue'),
        children: [
            {
                path: '',
                component: () => import('@/views/index/home/index.vue')
            },
            {
                path: PageEnum.LATEST_NOTICE,
                component: () => import('@/views/index/latest_notice/index.vue')
            },
            {
                path: PageEnum.FILING_FLOW,
                component: () => import('@/views/index/filing_flow/index.vue')
            },
            {
                path: PageEnum.LAWS_REGULATIONS,
                component: () =>
                    import('@/views/index/laws_regulations/index.vue')
            },
            {
                path: PageEnum.SYSTEM_HELP,
                component: () => import('@/views/index/system_help/index.vue')
            },
            {
                path: PageEnum.DETAIl,
                component: () => import('@/views/index/details_all/index.vue')
            }
        ]
    },
    // 新的登录页面
    {
        path: PageEnum.LOGIN,
        component: () => import('@/views/login/index.vue')
    },
    // 新的注册页面
    {
        path: PageEnum.REGISTER,
        component: () => import('@/views/register/index.vue')
    },
    // 找回密码页面
    {
        path: PageEnum.RETRIEVE,
        component: () => import('@/views/retrieve_password/index.vue')
    },
    {
        path: '/user',
        component: LAYOUT,
        children: [
            {
                path: 'setting',
                component: () => import('@/views/user/setting.vue'),
                name: Symbol(),
                meta: {
                    title: '个人设置'
                }
            }
        ]
    },
    {
        path: '/test',
        meta: {
            title: '测试'
        },
        component: () => import('@/views/test/index.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/error/404.vue')
    }
    // {
    //     path: '/dev_tools',
    //     component: LAYOUT,
    //     children: [
    //         {
    //             path: 'code/edit',
    //             component: () => import('@/views/dev_tools/code/edit.vue'),
    //             meta: {
    //                 title: '编辑数据表',
    //                 activeMenu: '/dev_tools/code'
    //             }
    //         }
    //     ]
    // },
    // {
    //     path: '/setting',
    //     component: LAYOUT,
    //     children: [
    //         {
    //             path: 'dict/data',
    //             component: () => import('@/views/setting/dict/data/index.vue'),
    //             meta: {
    //                 title: '数据管理',
    //                 activeMenu: '/setting/dict'
    //             }
    //         }
    //     ]
    // }
]

export const INDEX_ROUTE: RouteRecordRaw = {
    path: PageEnum.INDEX,
    component: LAYOUT,
    name: INDEX_ROUTE_NAME
}
